import api from '../api';
import { Strayyo } from '../../types';

export const strayyoService = {
  async getAll(): Promise<Strayyo[]> {
    const response = await api.get('/admin/strayyos');
    return response.data;
  },

  async getById(id: string): Promise<Strayyo> {
    const response = await api.get(`/admin/strayyos/${id}`);
    return response.data;
  },

  async update(id: string, data: Partial<Strayyo>): Promise<Strayyo> {
    const response = await api.put(`/admin/strayyos/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/admin/strayyos/${id}`);
  },

  async getImages(id: string) {
    const response = await api.get(`/admin/strayyos/${id}/images`);
    return response.data;
  },

  async uploadImage(id: string, file: File): Promise<void> {
    const formData = new FormData();
    formData.append('image', file);
    await api.post(`/admin/strayyos/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  async deleteImage(strayyoId: string, imageId: string): Promise<void> {
    await api.delete(`/admin/strayyos/${strayyoId}/images/${imageId}`);
  },
};
